import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ModalDlg } from '../../config/modal.config';

export type ModalState = {
  modalDlg: ModalDlg | null;
};

const initialState: ModalState = {
  modalDlg: null,
};

const modal = createSlice({
  name: 'modal',
  initialState,
  reducers: {
    showModal: (state, { payload: modalDlg }: PayloadAction<ModalDlg>) => ({
      ...state,
      modalDlg,
    }),
    closeModal: () => initialState,
  },
});

export const { showModal, closeModal } = modal.actions;
export default modal.reducer;
